document.addEventListener('DOMContentLoaded', () => {
  const initScrollTop = (container) => {
    const btn = container.querySelector('.wb-scroll-btn');
    if (!btn) return;

    const toggleVisibility = () => {
      if (window.scrollY > 300 || document.body.classList.contains('is-editor')) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    };

    const scrollToTop = (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    window.addEventListener('scroll', toggleVisibility);
    btn.addEventListener('click', scrollToTop);
    
    toggleVisibility();
  };

  document.querySelectorAll('.wb-scroll-wrapper').forEach(wrapper => {
    initScrollTop(wrapper.parentElement);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const container = document.querySelector(`[data-section-id="${e.detail.sectionId}"]`);
    if (container) initScrollTop(container);
  });
  
  document.addEventListener('shopify:section:select', (e) => {
    const btn = document.querySelector(`[data-section-id="${e.detail.sectionId}"] .wb-scroll-btn`);
    if(btn) btn.classList.add('is-visible');
  });
});